import german from 'dayjs/locale/de';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from './utils/dayjsConfig';

export const DayjsLocaleListener = () => {
  const { i18n } = useTranslation();
  useEffect(() => {
    if (i18n.language === 'de') {
      dayjs.locale(german);
    } else if (i18n.language === 'en') {
      // We are not loading the en locale by design.
      // The default english locale for english overrides the localizedFormat plugin.
      // The issue is that the default export does not include the formats object.
      // This causes all the format('l') functions to crash with type errors (the L works though).
      dayjs.locale('en');
    }
  }, [i18n.language]);
  return null;
};
